const LocalStorageKeys = {
  ACCESS_TOKEN: "ACCESS_TOKEN",
  REFRESH_TOKEN: "REFRESH_TOKEN",
  USER_ID: "USER_ID",
  USER_DETAILS: "USER_DETAILS",
};

export default LocalStorageKeys;
